import { keys } from '../constants/keys.esm.js';
import { same } from './same.esm.js';
import { trim } from './trim.esm.js';

var layoutNameIsValid = function layoutNameIsValid(input, predefinedLayoutNames) {
  var layoutName = trim(input);
  if (!(layoutName !== null && layoutName !== void 0 && layoutName.length)) {
    return false;
  }
  if (same(layoutName, keys.custom)) {
    return false;
  }
  if (same(layoutName, keys["default"])) {
    return false;
  }
  if (predefinedLayoutNames) {
    if (predefinedLayoutNames.some(function (n) {
      return same(layoutName, n);
    })) {
      return false;
    }
  }
  return layoutName.length > 1;
};

export { layoutNameIsValid };
//# sourceMappingURL=layout-name-is-valid.esm.js.map
